import React from "react";
import {
  TableRow,
  TableCell,
  StatusBadge,
  ButtonContainer,
  Button,
} from "../styled/userManagement/UserManageStyle";
import { useCustomAlertStore } from "../../Store/store";
import { ChangeCompanyStatus } from "../../api/userManagementAPI";

export default function CompanyTBody({ company, index, onDataChange }) {
  const { showSuccessAlert, showErrorAlert, showConfirmAlert } =
    useCustomAlertStore();

  const handleApprove = async () => {
    showConfirmAlert(
      "회원 승인",
      `${company.name} 회원을 승인하시겠습니까?`,
      async () => {
        try {
          // TODO: API 호출
          const response = await ChangeCompanyStatus(company.id, 1);

          showSuccessAlert("승인 완료", "회원이 승인되었습니다.");
          onDataChange();
        } catch (error) {
          console.error("승인 실패:", error);
          showErrorAlert("승인 실패", "회원 승인에 실패했습니다.");
        }
      },
    );
  };

  const handleSuspend = async () => {
    showConfirmAlert(
      "회원 탈퇴",
      `${company.name} 회원을 탈퇴 처리하시겠습니까?`,
      async () => {
        try {
          // TODO: API 호출
          const response = await ChangeCompanyStatus(company.id, 2);

          showSuccessAlert("탈퇴 완료", "회원이 탈퇴 처리되었습니다.");
          onDataChange();
        } catch (error) {
          console.error("탈퇴 실패:", error);
          showErrorAlert("탈퇴 실패", "회원 탈퇴 처리에 실패했습니다.");
        }
      },
    );
  };

  const getStatusText = (status) => {
    switch (`${status}`) {
      case "1":
        return "승인";
      case "2":
        return "거절";
      case "3":
        return "대기";
      default:
        return status || "대기";
    }
  };

  const getStatusClass = (status) => {
    switch (`${status}`) {
      case "1":
        return "approved";
      case "2":
        return "rejected";
      case "3":
        return "pending";
      default:
        return status || "pending";
    }
  };
  return (
    <TableRow>
      <TableCell>{index + 1}</TableCell>
      <TableCell>{company.name || "-"}</TableCell>
      <TableCell>{company.businessNumber || "-"}</TableCell>
      <TableCell>{company.description || "-"}</TableCell>
      <TableCell>
        <StatusBadge className={getStatusClass(company.status)}>
          {getStatusText(company.status)}
        </StatusBadge>
      </TableCell>
      <TableCell>
        <ButtonContainer>
          <Button
            className="approve-button"
            disabled={
              `${company.status}` === "1" || `${company.status}` === "3"
            }
            onClick={handleApprove}
          >
            승인
          </Button>
          <Button
            className="reject-button"
            disabled={
              `${company.status}` === "3" || `${company.status}` === "2"
            }
            onClick={handleSuspend}
          >
            탈퇴
          </Button>
        </ButtonContainer>
      </TableCell>
    </TableRow>
  );
}
